import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { NgClass } from '@angular/common';

import { IconComponent } from '@atoms/icon/icon.component';
import { ModalGeneratorComponent } from '@layout/modal-generator/modal-generator.component';
import { LayoutService } from '@services/layout.service';
import { ModalService } from '@services/modal.service';
import { SsrService } from '@services/ssr.service';

@Component({
  selector: 'app-modal',
  imports: [NgClass, IconComponent, ModalGeneratorComponent],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  private cd = inject(ChangeDetectorRef);
  private layoutService = inject(LayoutService);
  private modalService = inject(ModalService);
  private ssrService = inject(SsrService);
  @Input() size?: 'min' | 'small' | 'medium' | 'large' = 'medium';
  @Input('close-position') closePosition: 'right' | 'left' = 'right';
  @Input() data?: any;
  @Output() closed = new EventEmitter<boolean>();
  public scrollY: number = 0;
  public modalAnimationIn: boolean = false;
  public modalAnimationOut: boolean = false;

  @HostListener('click', ['$event.target']) onClick(e: HTMLElement): void {
    if (e.classList.contains('modal')) this.close();
  }

  close(): void {
    this.modalAnimationOut = true;
    setTimeout(() => {
      this.closed.emit(true);
      this.modalService.close();
      this.cd.detectChanges();
    }, 260);
  }

  ngOnInit(): void {
    if (this.ssrService.isServer()) return;
    this.layoutService.disableScroll('modal');
    this.scrollY = window.scrollY;
  }

  ngOnDestroy(): void {
    if (this.ssrService.isServer()) return;
    if (document.querySelectorAll('app-modal').length <= 1) this.layoutService.enableScroll('modal');
    window.scrollTo(0, this.scrollY);
  }
}
